<script lang="ts" setup>
import IChevron from '~/assets/images/events/icon-chevron.svg?component'

const props = defineProps<{
  checked?: boolean
}>()

const [isShowDropDownRef, toggle] = useToggle()
</script>

<template>
  <div
    class="flex flex-row items-center justify-between border border-solid border-[#626265] rounded-4 w-full pt-2 pl-7 pr-5.5 pb-2.5 cursor-pointer transition-all"
    :class="{ 'border-[#7540EE]': checked }"
  >
    <div class="flex flex-col w-full">
      <div class="flex flex-row items-center">
        <div class="min-w-2 h-2 rounded-full bg-[#7540EE]" />
        <p class="text-base tracking-wide ml-2">
          <slot name="title" />
        </p>
      </div>
      <p class="text-[#626265] text-xs"><slot name="text" /></p>
      <p class="text-base"><slot name="price" /></p>

      <p v-if="isShowDropDownRef || checked" class="w-74 mt-6 line-clamp-5">
        <slot name="description" />
      </p>
    </div>
    <IChevron
      v-if="!checked"
      class="mx-auto mt-1.5 transition-all"
      :class="{ 'transform rotate-180': isShowDropDownRef }"
      @click="toggle()"
    />
  </div>
</template>
